import React, { Component } from "react"
import { connect } from "react-redux"
import { Field, reduxForm } from "redux-form"
import { changePassword } from "../actions"
import { Panel, Row, Col, Modal, Button } from 'react-bootstrap'
import NavHeader from './navheader'
import SubMenu from './submenu'
import Footer from './footer'

class PasswordPage extends Component {

    state = {
        showPassword: false,
        loading: false,
        showModal: false,
        modalWording: '',
    }

    componentWillMount() {
        if (localStorage.getItem('user') == null) {
            this.props.history.push('/login')
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    onSubmit(values) {
        values.phone_number = JSON.parse(localStorage.getItem('user')).phone_number
        this.props.changePassword(values, this.callback.bind(this), this.callbackerr.bind(this))
    }

    callback() {
        this.setState({ showModal: true, modalWording: 'เปลี่ยนรหัสผ่านสำเร็จ' })
    }

    callbackerr(responseCode) {
        if (responseCode == 400) {
            this.setState({ showModal: true, modalWording: 'รหัสผ่านผิดพลาด' })
        } else {
            this.setState({ showModal: true, modalWording: 'เกิดข้อผิดพลาด' })
        }
    }

    onLogOut() {
        // window.Intercom('shutdown')
        // window.Intercom('boot', {
        //     app_id: 'j77n0bkz',
        // });
        localStorage.removeItem('user')
        this.props.history.push('/login')
    }

    closeModal() {
        if (this.state.modalWording == 'เปลี่ยนรหัสผ่านสำเร็จ') {
            this.props.history.push('/user_info')
        } else {
            this.setState({ showModal: false, modalWording: '' })
        }
    }

    renderField(field) {
        const { meta: { touched, error } } = field;
        const className = `form-group ${touched && error ? "has-danger" : ""}`;
        return (
            <div className={className}>
                <input placeholder={field.placeholder} className="form-control" type={field.type} {...field.input} />
                <div className="text-help">
                    {touched ? error : ""}
                </div>
            </div>
        )
    }

    render() {
        const { handleSubmit } = this.props
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg" style={{ height: '700px' }}>
                    <Row>
                        <Col md={3} sm={1} xs={0}>
                        </Col>
                        <Col md={6} sm={10} xs={12}>
                            <div style={{ padding: '10px', textAlign: 'center', marginTop: 25 }}>
                                <img src="../../static/images/logo_songsod_blue.png" style={{ width: '20%' }} />
                            </div>
                            <Panel style={{ backgroundColor: '#fafafa' }}>
                                <div className="section-message">
                                    <h3 className="section-message-content">เปลี่ยนรหัสผ่าน</h3>
                                </div>
                                <form onSubmit={handleSubmit(this.onSubmit.bind(this))} >
                                    <small>รหัสผ่านเดิม</small>
                                    <Field
                                        placeholder="กรุณากรอกรหัสผ่านเดิม"
                                        name="password"
                                        type={this.state.showPassword ? 'text' : 'password'}
                                        component={this.renderField}
                                    />
                                    <small>รหัสผ่านใหม่</small>
                                    <Field
                                        placeholder="กรุณากรอกรหัสผ่านใหม่"
                                        name="new_password"
                                        type={this.state.showPassword ? 'text' : 'password'}
                                        component={this.renderField}
                                    />
                                    <small>ยืนยันรหัสผ่านใหม่</small>
                                    <Field
                                        placeholder="กรุณายืนยันรหัสผ่าน"
                                        name="confirm_password"
                                        type={this.state.showPassword ? 'text' : 'password'}
                                        component={this.renderField}
                                    />

                                    <button type="submit" className="btn btn-success max-width"
                                        disabled={this.state.loading}
                                    >
                                        {this.state.loading ? 'กรุณารอสักครู่...' : 'เปลี่ยนรหัสผ่าน'}
                                    </button>
                                </form>
                                <br />
                                <div className="section-message">
                                    <h3 className="section-message-content">ลืมรหัสผ่าน ?</h3>
                                </div>
                                <button className='btn btn-success max-width' onClick={() => {
                                    window.location = '/forget_password'
                                }} >ลืมรหัสผ่าน</button>

                            </Panel>
                        </Col>
                    </Row>
                </div>
                <Footer history={this.props.history} />
                <Modal show={this.state.showModal} onHide={() => { this.closeModal() }}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.modalWording}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ textAlign: 'center' }}>
                        {
                            this.state.modalWording
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle="primary" onClick={() => {
                            this.state.modalWording === 'เปลี่ยนรหัสผ่านสำเร็จ' ?
                                this.onLogOut()
                                : this.closeModal()
                        }}>ตกลง</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

function validate(values) {
    const errors = {}
    if (!values.password) {
        errors.password = 'กรุณาใส่รหัสผ่าน'
    }
    if (!values.new_password) {
        errors.new_password = 'กรุณาใส่รหัสผ่าน'
    }
    if (!values.confirm_password) {
        errors.confirm_password = 'กรุณายืนยันรหัสผ่าน'
    }
    if (values.new_password !== values.confirm_password) {
        errors.confirm_password = 'รหัสผ่านไม่ตรงกัน'
    }
    return errors;
}

export default reduxForm({
    validate,
    form: "PasswordForm"
})(connect(null, { changePassword })(PasswordPage))


// WEBPACK FOOTER //
// ./src/components/passwordPage.js